import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"Apostille ใบรับรองความประพฤติ (PCSC) — ใช้ยื่นวีซ่า/PR ต่างประเทศ","metaTitle":"Apostille Police Clearance Thailand PCSC 4,500 บาท | NYC","metaDesc":"Apostille ใบรับรองความประพฤติไทย (PCSC) สำหรับยื่นวีซ่า PR ทำงานต่างประเทศ ครอบคลุม 130 ประเทศ Hague ค่าบริก — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที"},"en":{"h1":"Apostille of Thai Police Clearance (PCSC) — 125 Hague countries","metaTitle":"Apostille Thai Police Clearance PCSC — THB 4,500 | NYC","metaDesc":"Apostille of Thai Police Clearance Certificate (PCSC) for PR, work, marriage, and study visas across 125 H — Send your documents for a free eligibility check."}} as const;

export const Route = createFileRoute("/en/apostille/police-clearance")({
  head: () => {
    const url = `${SEO_SITE}/en/apostille/police-clearance`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/apostille/police-clearance", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/apostille/police-clearance", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/apostille/police-clearance", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/apostille/police-clearance", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/apostille/police-clearance", "/en/apostille/police-clearance")],
    };
  },
  component: () => <SubServicePage slug="apostille/police-clearance" locale="en" />,
});
